import { render, staticRenderFns } from "./EModalEditEvento.vue?vue&type=template&id=0f02bba9"
import script from "./EModalEditEvento.vue?vue&type=script&lang=js"
export * from "./EModalEditEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports